/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgTickets } from '../../models/esg-tickets';

export interface EsgTicketListForProfile$Params {
  profileId: number;
}

export function esgTicketListForProfile(http: HttpClient, rootUrl: string, params: EsgTicketListForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
  const rb = new RequestBuilder(rootUrl, esgTicketListForProfile.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EsgTickets>;
    })
  );
}

esgTicketListForProfile.PATH = '/esg/profile/{profileId}/esg/ticket';
